// Generated by CoffeeScript 2.7.0
export var icons = {
  strong: "text-bold",
  underline: "text-underline",
  em: "text-italic",
  strikethrough: "text-strikethrough",
  code: "code",
  blockquote: "quote",
  link: "link",
  ordered_list: "list-ol",
  bullet_list: "list-ul",
  lift: "outdent",
  align_left: "align-left",
  align_center: "align-center",
  align_right: "align-right",
  align_justify: "align-justify",
  image: "image",
  heading: "font",
  text_color: "text-color",
  text_bg_color: "text-background-color",
  undo: "reply",
  redo: "forward",
  table: "table",
  clear: "clear",
  hr: "minus"
};

export var colorList = ['#ffffff', '#ef9a9a', '#fff59d', '#ffcc80', '#a5d6a7', '#80deea', '#90caf9', '#ce93d8', '#e0e0e0', '#e57373', '#fff176', '#ffa726', '#81c784', '#4dd0e1', '#64b5f6', '#ba68c8', '#9e9e9e', '#f44336', '#ffeb3b', '#ff9800', '#4caf50', '#00bcd4', '#2196f3', '#9c27b0', '#616161', '#d32f2f', '#fbc02d', '#f57c00', '#388e3c', '#0097a7', '#1976d2', '#7b1fa2', '#313131', '#c62828', '#f9a825', '#ef6c00', '#2e7d32', '#00838f', '#1565c0', '#6a1b9a'];

export var headingList = [1, 2, 3, 4, 5, 6, false];

export var ALIGN_REGEX = /(left|right|center)/;

export var ALLOW_ALIGN_NODE_TYPES = ['heading', 'list_item', 'paragraph'];
